import { DEFAULT_SEARCH_COMBO } from 'modules/workflows/constants/triggers';

export const DEFAULT_SEARCH_COMBINATOR = DEFAULT_SEARCH_COMBO.combinator;
export const DEFAULT_SEARCH_DATATYPE = 'customEvent';

// comparators for filtering properties

export type ComparatorOption = {
  type: string;
  displayName: string;
  displayNameMulti?: string;
};

export type ComparatorArray = ComparatorOption[];

export const comparatorIcons: { [key: string]: string } = {
  Equals: '=',
  DoesNotEqual: '≠',
  GreaterThan: '>',
  GreaterThanOrEqualTo: '≥',
  LessThan: '<',
  LessThanOrEqualTo: '≤',
  IsSet: '∃',
};

export const listTypeComparators: ComparatorArray = [
  {
    type: 'Equals',
    displayName: 'Includes',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Does Not Include',
    displayNameMulti: 'Includes Anything But',
  },
];

export const dateTypeComparators: ComparatorArray = [
  {
    type: 'GreaterThan',
    displayName: 'Is After',
  },
  {
    type: 'GreaterThanOrEqualTo',
    displayName: 'Is on or After',
  },
  {
    type: 'LessThan',
    displayName: 'Is Before',
  },
  {
    type: 'LessThanOrEqualTo',
    displayName: 'Is on or Before',
  },
  {
    type: 'Equals',
    displayName: 'Is Exactly',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Is Not',
    displayNameMulti: 'Is Any Time Except',
  },
  {
    type: 'IsSet',
    displayName: 'Is Set',
  },
];

export const stringTypeComparators: ComparatorArray = [
  {
    type: 'Equals',
    displayName: 'Equals',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Does Not Equal',
    displayNameMulti: 'Equals Anything But',
  },
  {
    type: 'IsSet',
    displayName: 'Is Set',
  },
  {
    type: 'StartsWith',
    displayName: 'Starts With',
  },
  {
    type: 'MatchesRegex',
    displayName: 'Matches Regex',
  },
  {
    type: 'Contains',
    displayName: 'Contains',
  },
];

export const booleanTypeComparators: ComparatorArray = [
  {
    type: 'Equals',
    displayName: 'Equals',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Does Not Equal',
    displayNameMulti: 'Equals Anything But',
  },
];

export const numericTypeComparators: ComparatorArray = [
  {
    type: 'GreaterThan',
    displayName: 'Greater Than',
  },
  {
    type: 'GreaterThanOrEqualTo',
    displayName: 'Greater Than Or Equal',
  },
  {
    type: 'LessThan',
    displayName: 'Less Than',
  },
  {
    type: 'LessThanOrEqualTo',
    displayName: 'Less Than Or Equal',
  },
  {
    type: 'Equals',
    displayName: 'Equals',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Does Not Equal',
    displayNameMulti: 'Equals Anything But',
  },
  {
    type: 'IsSet',
    displayName: 'Is Set',
  },
];

export const campaignLabelComparators: ComparatorArray = [
  {
    type: 'Equals',
    displayName: 'Equals',
  },
];

export const messageTypeComparators: ComparatorArray = [
  {
    type: 'Equals',
    displayName: 'Equals',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Does Not Equal',
  },
];

export const brandAffinityComparators: ComparatorArray = [
  {
    type: 'Equals',
    displayName: 'Equals',
  },
  {
    type: 'DoesNotEqual',
    displayName: 'Does Not Equal',
    displayNameMulti: 'Equals Anything But',
  },
  {
    type: 'IsSet',
    displayName: 'Is Set',
  },
];

export const BRAND_AFFINITY_FIELD = 'itblDS.brandAffinityLabel';
export const BRAND_AFFINITY_DISPLAY = 'brandAffinityLabel';

export const defaultComparators: ComparatorArray = [
  { type: 'Contains', displayName: 'Contains' },
  { type: 'DoesNotEqual', displayName: 'Does Not Equal' },
  { type: 'Equals', displayName: 'Equals' },
  { type: 'GreaterThan', displayName: 'Greater Than' },
  { type: 'GreaterThanOrEqualTo', displayName: 'Greater Than Or Equal To' },
  { type: 'IsNotSet', displayName: 'Is Not Set' },
  { type: 'IsSet', displayName: 'Is Set' },
  { type: 'LessThan', displayName: 'Less Than' },
  { type: 'LessThanOrEqualTo', displayName: 'Less Than Or Equal To' },
  { type: 'MatchesRegex', displayName: 'Matches Regex' },
  { type: 'StartsWith', displayName: 'Starts With' },
];
